import React, { useEffect } from "react"
import { Grid } from "@mui/material"
import { SelectSeeker } from "@ui-seeker/core"
import { RENTAL_DATES_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"
import SpecificDaysField from "./SpecificDays"
import LeadTimeDaysField from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields/SearchConfig/PickupDates/LeadTimeDays"
import DaySelector from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields/SearchConfig/PickupDates/Days"
import WeekSelector from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields/SearchConfig/PickupDates/Weeks"
import NextFullMonthField from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields/SearchConfig/PickupDates/FullMonth"
import { isEmpty } from "@ui-seeker/utils"


const options = [
	{ label: 'Specific days', value: RENTAL_DATES_OPTIONS.SPECIFIC_DAYS },
	{ label: 'Lead times days', value: RENTAL_DATES_OPTIONS.LEAD_TIMES },
	{ label: 'Day and week', value: RENTAL_DATES_OPTIONS.DAY_SELECTED },
	{ label: 'Next full month in', value: RENTAL_DATES_OPTIONS.FULL_MONTH }
]

export default function PickupDatesSubSection() {

	const {
		rentalDateOption,
		setRentalDateOptionInfo
	} = useReportFormInfo(reportFormData.peek().rentalDateOption, "rentalDateOption", object({ rentalDateOption: string().required("Must select a pickup option") }))

	useEffect(() => {
		return () => {
			if (!rentalDateOption && !isEmpty(reportFormData.value)) setRentalDateOptionInfo(RENTAL_DATES_OPTIONS.SPECIFIC_DAYS)
		}
	}, [rentalDateOption])

	return <Grid container spacing={2}>
		<Grid item xs={3}>
			<SelectSeeker
				options={options}
				value={rentalDateOption}
				onChange={e => setRentalDateOptionInfo(e.target.value)}
			/>
		</Grid>
		<Grid item xs={4}>
			{rentalDateOption === RENTAL_DATES_OPTIONS.SPECIFIC_DAYS && <SpecificDaysField/>}
			{rentalDateOption === RENTAL_DATES_OPTIONS.LEAD_TIMES && <LeadTimeDaysField/>}
			{rentalDateOption === RENTAL_DATES_OPTIONS.FULL_MONTH && <NextFullMonthField/>}
			{rentalDateOption === RENTAL_DATES_OPTIONS.DAY_SELECTED && <Grid container spacing={2}>
				<Grid item xs={6}>
					<DaySelector/>
				</Grid>
				<Grid item xs={6}>
					<WeekSelector/>
				</Grid>
			</Grid>}
		</Grid>
	</Grid>
}